class LinkedinAutofillBtn {
	constructor(drForm) {
		// Note: LinkedIn Autofill button need to be after init of intlTelInput phone formatting
		this.form = drForm;
		this.inFormScript = this.form.querySelector('script[type="IN/Form2"]');
		this.maybeInit();
	}

	maybeInit() {
		if (this.inFormScript && this.isAbleToUse()) {
			this.updateInFormScript();
			LinkedinAutofillBtn.generate(this.inFormScript);
		}
	}

	isAbleToUse() {
		let iOSDevice = /iphone|ipod|ipad/i.test(navigator.userAgent),
			iOSVersion = (function () {
				let iOSVersion = window.navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/),
					version = 0;
				if (iOSVersion && iOSVersion.length > 1) {
					version = parseInt(iOSVersion[1]);
				}

				return version;
			})(),
			browserName = navigator.sayswho.browser,
			browserVersion = navigator.sayswho.version;

		return (!iOSDevice && (browserName !== 'Safari' || (browserName === 'Safari' && browserVersion < 13)))
			|| (iOSDevice && iOSVersion < 13);
	}

	updateInFormScript() {
		let identifier = 'field';
		for (let key in this.inFormScript.dataset) {
			if (key.indexOf(identifier) === 0) {
				let field = this.form.querySelector(this.inFormScript.dataset[key]);
				if (field) {
					this.inFormScript.dataset[key] = field.id;
				}
			}
		}
	}

	/**
	 * This script is a modification of original https://www.linkedin.com/autofill/js/autofill.js script
	 * Changelist:
	 * - put script inside class as static function to preserve function code as native as possible
	 * - render an autofill button for the specified form using inFormScript data passed to function
	 * - can render button for each of multiple forms on page
	 *
	 * inFormScript - <script type="IN/Form2" ...></script> node for rendering Linkedin Autofill button
	 **/
	static generate(inFormScript) {
		/**
		 * Fast UUID generator, RFC4122 version 4 compliant.
		 * Modified to use crypto.getRandomValues if available.
		 * author Jeff Ward (jcward.com).
		 * license MIT license
		 * link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
		 **/
		var UUID = (function () {
				var self = {};
				var lut = [];
				for (var i = 0; i < 256; i++) {
					lut[i] = (i < 16 ? '0' : '') + (i).toString(16);
				}
				var numGen = (typeof (window.crypto) != 'undefined' && typeof (window.crypto.getRandomValues) != 'undefined') ?
					function () {
						var buf = new Uint32Array(4);
						window.crypto.getRandomValues(buf);
						return buf;
					} :
					function () {
						return [Math.random() * 0xffffffff | 0, Math.random() * 0xffffffff | 0, Math.random() * 0xffffffff | 0, Math.random() * 0xffffffff | 0];
					};

				self.generate = function () {
					var d = numGen();
					return lut[d[0] & 0xff] + lut[d[0] >> 8 & 0xff] + lut[d[0] >> 16 & 0xff] + lut[d[0] >> 24 & 0xff] + '-' +
						lut[d[1] & 0xff] + lut[d[1] >> 8 & 0xff] + '-' + lut[d[1] >> 16 & 0x0f | 0x40] + lut[d[1] >> 24 & 0xff] + '-' +
						lut[d[2] & 0x3f | 0x80] + lut[d[2] >> 8 & 0xff] + '-' + lut[d[2] >> 16 & 0xff] + lut[d[2] >> 24 & 0xff] +
						lut[d[3] & 0xff] + lut[d[3] >> 8 & 0xff] + lut[d[3] >> 16 & 0xff] + lut[d[3] >> 24 & 0xff];
				};
				return self;
			})(),
			initAutofill = function () {
				var uuid = UUID.generate(),
					host = 'https://www.linkedin.com',
					// Create iframe here to use it in child functions
					autofillFrame = document.createElement('iframe'),
					frameSource = host + '/autofill/',
					formToFill,
					sendEvent = function (eventType, data) {
						var url = host + '/autofill/track/',
							request;

						data = data ? data : {};

						data.eventType = eventType;
						data.uuid = uuid;
						data = JSON.stringify(data);

						if (window.navigator && window.navigator.sendBeacon && window.Blob) {
							window.navigator.sendBeacon(url, new window.Blob([data], {
								type: 'text/plain'
							}));
						} else {
							request = new XMLHttpRequest();
							request.withCredentials = true;
							request.open('POST', url, true);
							request.setRequestHeader('Content-type', 'text/plain');

							request.send(data);
						}
					},
					updateInput = function (element) {
						// Fill in Phone input
						if (window.intlTelInputGlobals && element.id === 'Phone') {
							window.intlTelInputGlobals.getInstance(element).setNumber(element.value);
						}
						// Update field appearance after value set
						element.dispatchEvent(new Event('blur'));
					},
					renderIframe = function () {
						// Create wrappers and add iframe on page
						var frameWrapperOuter = document.createElement('span'),
							frameWrapperInner = document.createElement('span');

						frameWrapperOuter.setAttribute('class', 'IN-widget');
						frameWrapperOuter.setAttribute('style', 'line-height: 1; vertical-align: baseline; display: inline-block;');

						frameWrapperInner.setAttribute('style', 'padding: 0 !important; margin: 0 !important; text-indent: 0 !important; display: inline-block !important; vertical-align: baseline !important; font-size: 1px !important;');
						frameWrapperInner.appendChild(autofillFrame);

						frameWrapperOuter.appendChild(frameWrapperInner);

						autofillFrame.setAttribute('frameborder', '0');
						autofillFrame.setAttribute('style', 'width: 185px; max-width: 100%; height: 33px; display: inline-block;');
						autofillFrame.addEventListener('load', autofillLoadListener, false);
						autofillFrame.src = frameSource;

						// Add a listener for processing "message" events which iframe will use for sending data to the parent window
						window.addEventListener('message', function (event) {
							if (event.origin !== host) {
								return;
							}

							var message,
								rawData,
								data = {},
								key,
								newKey,
								keyMap = {},
								fieldsFilled = [];

							// Check message type to choose logic
							try {
								message = JSON.parse(event.data);
								if (message.type === 'formData') {
									// Yoohoo! We have got user data from Linkedin account
									rawData = message.data;
								} else if (message.type === 'reload') {
									// Update iframe content after successful login to Linkedin
									autofillFrame.src = frameSource;
									return;
								} else if (message.type === 'size') {
									// Update button size after loading iframe depending on its content
									// Iframe content is different for authorized/unauthorized user
									if (message.data.width !== '0px') {
										autofillFrame.style.width = message.data.width;
									}
									autofillFrame.style.height = message.data.height;
									return;
								} else {
									return;
								}
							} catch (e) {
								return;
							}

							// Collect field names and values to fill
							// data = { filedName: valueToFill, ... }
							// keyMap = { newKey: oldKey }
							for (key in rawData) {
								if (rawData.hasOwnProperty(key)) {
									newKey = inFormScript.getAttribute('data-field-' + key);

									if (newKey && newKey.length > 0) {
										data[newKey.toLowerCase()] = rawData[key];
										keyMap[newKey.toLowerCase()] = key;
									} else {
										data[key] = rawData[key];
										keyMap[key] = key;
									}
								}
							}

							// Take all form fields
							[].slice.call(formToFill.elements).filter(function (element) {
								// Find inputs, selects, textareas
								var nodeName = element.nodeName.toLowerCase(),
									type = element.getAttribute('type');

								if (!nodeName || (nodeName !== 'input' && nodeName !== 'select' && nodeName !== 'textarea')) {
									return false;
								}

								return !(type && type.length > 0 && type.trim().toLowerCase() === 'hidden');
							}).forEach(function (element) {
								// Process each founded field
								var attributeList = [
									'data-in-profile',
									'placeholder',
									'name',
									'id'
								];

								// Check field attributes
								attributeList.some(function (attributeName) {
									var attr = element.hasAttribute(attributeName) ? element.getAttribute(attributeName).toLowerCase() : false,
										options;

									// If field has attribute used to choose field for filling
									if (attr && data.hasOwnProperty(attr)) {
										// Set field value depending on its type
										if (element.nodeName.toLowerCase() === 'select') {
											options = element.getElementsByTagName('option');

											// Find the option value that need to be chosen
											[].slice.call(options).some(function (option) {
												var value = data[attr].toLowerCase();
												if (option.value && option.value.toLowerCase() === value) {
													option.selected = true;
													// Trigger field updating
													updateInput(element);
													return true;
												}
											});
										} else {
											element.value = data[attr];
											// Trigger field updating
											updateInput(element);
										}

										// Collect fields which were been filled
										fieldsFilled.push(keyMap[attr]);
										return true;
									}
								});
							});

							// Track fields filling
							sendEvent('click', {
								fieldsFilled: fieldsFilled
							});
						}, false);

						inFormScript.parentElement.insertBefore(frameWrapperOuter, inFormScript);
					},
					autofillLoadListener = function () {
						// Remove load listener from iframe after it was loaded
						autofillFrame.removeEventListener('load', autofillLoadListener);
						sendEvent('impression');

						// Add submit listener on form to send event to Linkedin
						formToFill.addEventListener('submit', function () {
							sendEvent('submit');
						});
					};

				// Check given node and try to find a form
				if (inFormScript) {
					formToFill = document.querySelector('[data-autofill-form-id="' + inFormScript.getAttribute('data-form') + '"] form');
				}

				// Only render the iframe if there is an actual form to fill
				if (formToFill && formToFill.nodeName.toLowerCase() === 'form') {
					renderIframe();
				}
			};

		if (document.readyState === 'complete') {
			initAutofill();
		} else {
			window.addEventListener('load', initAutofill, false);
		}
	}
}

export default LinkedinAutofillBtn;
